import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const run = async () => {
      const hash = window.location.hash || "";
      const sessionId = hash.match(/session_id=([^&]+)/)?.[1];
      if (!sessionId) {
        navigate("/admin/login", { replace: true });
        return;
      }
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        setUser(data);
        // clear the fragment and go to dashboard
        window.history.replaceState({}, document.title, "/admin");
        navigate("/admin", { replace: true });
      } catch (e) {
        const msg = formatApiError(e.response?.data?.detail) || "Google sign-in failed";
        setError(msg);
        toast.error(msg);
        setTimeout(() => navigate("/admin/login", { replace: true }), 1500);
      }
    };
    run();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-zinc-50" data-testid="auth-callback">
      <div className="text-center">
        <div className="overline mb-3">Signing you in</div>
        <p className="text-zinc-600 font-mono text-sm">{error || "Completing Google sign-in…"}</p>
      </div>
    </div>
  );
}
